// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { PanelSettingsScreen } from "../screen/PanelSettingsScreen.js";
import { AlertAction, AlertActions, AlertSubImage } from "../../Utils/Alert/AlertConstants.js";
import { AlertPanelTopTemplate } from "../../templates.js";
import { AlertItem } from "../cache/AlertItem.js";
import { PanelNames } from "../UtilsClasses/FactoryConstants.js";
import { ApplicationPanelNew } from "./ApplicationPanelNew.js";
import { TerceraMenu } from "../elements/TerceraMenu.js";
import { GeneralSettings } from "../../Utils/GeneralSettings/GeneralSettings.js";
import { DataCache } from "../../Commons/DataCache.js";
import { SessionSettings } from "../../Commons/SessionSettings.js";
import { MainWindowManager } from "../UtilsClasses/MainWindowManager.js";

export let AlertPanel = ApplicationPanelNew.extend(
    {
        topPanelHeight: 25,
        data: function ()
        {
            return {
                width: 390,
                height: 533,
                isAccountLinkShow: false,
                isSymbolLinkShow: false,
                dockablePanel: false,
                showHeader: true,
                showFooter: false,
                resizable: false,
                movable: false,
                canAddAlert: true,
                closeBtnVisible: false,
                style_addition_header: 'js-PropertySetupScreen-AdditionalHeader',
                btnTooltip: "",
                canLinkByAccount: false
            }
        },
        partials: {
            bodyPartial: AlertPanelTopTemplate
        },
        headerLocaleKey: 'screen.Alerts',
        rangeSelectPanel: null,
        skipOnSave: true,
        AlertBTN: null
    });

AlertPanel.prototype.getType = function () { return PanelNames.AlertPanel };


AlertPanel.prototype.oncomplete = function ()
{
    ApplicationPanelNew.prototype.oncomplete.apply(this)

    this.AlertBTN = MainWindowManager.MainWindow.Controls.alert;
    this.on('onAddClick', this.onAdd);
    this.observe("visible", function (val) { this.AlertBTN.set("focused", val); });
    this.populateItems();

    DataCache.AlertManager.OnAlertAdded.Subscribe(this.alertsAdded, this);
    DataCache.AlertManager.OnAlertRemoved.Subscribe(this.alertsRemoved, this);
    this.quickTableRactive.quickTable.OnPaintedPictureButtonClick.Subscribe(this.onPaintedPictureButtonClick, this);
    this.quickTableRactive.quickTable.lockManualSorting = true;

    this.populateTableContextMenu();
}


AlertPanel.prototype.populateTableContextMenu = function ()
{
    var items = [];

    items.push(
        {
            text: Resources.getResource('screen.Alerts.Settings.ContextMenu'),
            event: this.ShowProperties.bind(this)
        }
    );

    this.quickTableRactive.quickTable.setTableContextMenuItems(items);
    this.menuTagDict = TerceraMenu.createTagDictionary(items);
};

AlertPanel.prototype.ShowProperties = function ()
{
    PanelSettingsScreen.EditProperties(this, null, Resources.getResource("screen.Alerts.Settings.Screen"))
}

AlertPanel.prototype.Properties = function ()
{
    // let properties = ApplicationPanelNew.prototype.Properties.call(this);
    // properties = properties.concat(SessionSettings.GetAlertPanelProperties())
    return SessionSettings.GetAlertPanelProperties();
};

AlertPanel.prototype.callBack = function (newProperties)
{
    // ApplicationPanelNew.prototype.callBack.call(this, newProperties);
    SessionSettings.AlertPanelCallBack(newProperties)
    SessionSettings.save();
};

AlertPanel.prototype.alertsAdded = function (alert)
{
    let alertItem = new AlertItem(alert, SessionSettings);
    this.quickTableRactive.quickTable.AddItem(alertItem);
}

AlertPanel.prototype.alertsRemoved = function (alert)
{
    this.quickTableRactive.quickTable.RemoveRow(alert.AlertId)
}

AlertPanel.prototype.populateItems = function (alert)
{
    let alerts = DataCache.AlertManager.GetAllAlerts();
    let hideOE = Resources.isHidden("screen.Alerts.Action.PlaceOrder");
    for (let i = 0; i < alerts.length; i++)
    {
        let alert = alerts[i];
        if (alert.Action === AlertAction.PLACE_ORDER_NOTIFY && hideOE)
            continue
        let alertItem = new AlertItem(alert, SessionSettings);
        this.quickTableRactive.quickTable.AddItem(alertItem);
    }
}

AlertPanel.prototype.layoutTable = function ()
{
    if (this.quickTableRactive === null)
        return;

    var margin = this.margin;
    var scrWidth = this.get('width');
    var bottomMargin = margin + 60;

    var scrHeight = this.ContentContainerHeight();

    this.quickTableRactive.setBounds(
        margin,
        margin,
        Math.abs(scrWidth - 2 * margin),
        Math.abs(scrHeight - margin - bottomMargin));

    let buttonTop = scrHeight - margin - bottomMargin + 25;
    let buttonWidth = scrWidth - 50;

    this.set('buttonTop', buttonTop);
    this.set('buttonWidth', buttonWidth);
}

AlertPanel.prototype.onAdd = function ()
{
    let panel = MainWindowManager.Factory.addPanel(PanelNames.CreateAlertPanel);
    panel.set({
        left: this.get('left'),
        top: this.get('top'),
    });
    panel.CallerPanel = this;
    panel.setFocus();
    this.AlertBTN.set("focused", true);
}

AlertPanel.prototype.populateItemsDirect = function ()
{
    ApplicationPanelNew.prototype.populateItemsDirect.apply(this)

    let trades = DataCache.newTradesDict;
    let keys = Object.keys(trades);
    let length = keys.length;

    for (let i = 0; i < length; i++)
        this.quickTableRactive.quickTable.AddItem(new AlertItem(trades[keys[i]], SessionSettings));
}

AlertPanel.prototype.onPaintedPictureButtonClick = function (data, event)
{
    let alert = data.row.item.alert;

    if (data.subItemIndex === AlertSubImage.PLAY_STOP)
        DataCache.AlertManager.MakeAlertAction(alert, (alert.Active ? AlertActions.STOP : AlertActions.START))

    if (data.subItemIndex === AlertSubImage.UPDATE)
    {
        let panel = MainWindowManager.Factory.addPanel(PanelNames.CreateAlertPanel);
        panel.set({ left: this.get('left'), top: this.get('top') });
        panel.setUpdateParams(alert);
        panel.CallerPanel = this;
        panel.setFocus();
        this.AlertBTN.set("focused", true);
    }

    if (data.subItemIndex === AlertSubImage.CLOSE)
    {
        DataCache.AlertManager.RemoveAlertProcess(alert, this.setFocus.bind(this));

        this.set({ visible: true });
    }

    return null;
}

AlertPanel.prototype.dispose = function ()
{
    DataCache.AlertManager.OnAlertAdded.UnSubscribe(this.alertsAdded, this);
    DataCache.AlertManager.OnAlertRemoved.UnSubscribe(this.alertsRemoved, this);
    // DataCache.AlertManager.OnAlertUpdated.UnSubscribe(this.alertsUpdated, this);
    ApplicationPanelNew.prototype.dispose.apply(this);
};

AlertPanel.prototype.localize = function ()
{
    ApplicationPanelNew.prototype.localize.apply(this);

    this.set('textButton', Resources.getResource('screen.Alerts.AddAlert'))
};

AlertPanel.prototype.SetColumnsDefaultDisplayIndex = function (table)
{
    table.columns[0].displayedIndex = 1;
    table.columns[1].displayedIndex = 2;
}

AlertPanel.prototype.lostFocus = function ()
{
    ApplicationPanelNew.prototype.lostFocus.apply(this)
    this.close();
}

AlertPanel.prototype.close = function ()
{
    this.set({ visible: false });
}

AlertPanel.prototype.getProperties = function ()
{
    let sett = GeneralSettings.Alert;
    let item = {
        "NotificationVariable": sett.NotificationVariable,
        "AlertTypeVariable": sett.AlertTypeVariable,
        "ConditionVariable": sett.ConditionVariable,
        "ImportanceVariable": sett.ImportanceVariable,
        "AfterExecuteVariable": sett.AfterExecuteVariable
    }

    return item;
}